import { useNavigate } from 'react-router-dom'

/** Гаджет: Рейтинг водителей. */

function RatingRow({ driver, onOpen }) {
  return (
    <li>
      <button type="button" className="rating__row" onClick={() => onOpen(driver.user_id)}>
        <span className="rating__name">{driver.name}</span>
        <span className="rating__trips">{driver.trips} поездок</span>
        <span className={`rating__score rating__score--${driver.level}`}>{driver.score}</span>
      </button>
    </li>
  )
}

export function DriverRatingWidget({ data }) {
  const navigate = useNavigate()
  const open = (id) => navigate(`/admin/users/${id}`)

  if (!data.top.length) {
    return <p className="widget-empty">Пока некого оценивать — нет поездок</p>
  }

  return (
    <div className="rating">
      <span className="rating__group">Лучшие</span>
      <ul className="widget-list">
        {data.top.map((d) => (
          <RatingRow key={d.user_id} driver={d} onOpen={open} />
        ))}
      </ul>

      {data.bottom.length > 0 && (
        <>
          <span className="rating__group">Требуют внимания</span>
          <ul className="widget-list">
            {data.bottom.map((d) => (
              <RatingRow key={d.user_id} driver={d} onOpen={open} />
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
